var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"session-tag-list"},_vm._l((_vm.filteredSessionTags),function(sessionTag){return _c('Tag',{key:sessionTag.id,attrs:{"data-test-id":"badge"}},[_vm._v("\n    "+_vm._s(_vm.transl8(sessionTag.name))+"\n  ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }